function Text() {
  return (
    <div className="px-4 mt-8 mb-4">
      <h3 className="text-2xl font-semibold text-gray-800 tracking-tight">
        NEW ARRIVALS
      </h3>
      <div className="h-1 w-16 bg-purple-600 rounded mt-2"></div>
    </div>
  );
}

export default Text;
